(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grid-item--product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const productGridItemLinks = document.querySelectorAll('[data-show-secondary-image]');
    let touchStartTime = 0;
    let hasNavigated = false;

    // Handle touch start
    productGridItemLinks.forEach(link => {
      link.addEventListener('touchstart', function(e) {
        touchStartTime = Date.now();
        this.classList.add('is-active');
      }, { passive: true });

      // Handle touch end
      link.addEventListener('touchend', function(e) {
        const touchDuration = Date.now() - touchStartTime;

        // If it's a quick tap (less than 300ms), navigate
        if (touchDuration < 300 && !hasNavigated) {
          hasNavigated = true;

          // Small delay to show the image change
          setTimeout(() => {
            window.location.href = this.href;
          }, 150);
        }
      }, { passive: true });

      // Handle touch cancel
      link.addEventListener('touchcancel', function(e) {
        this.classList.remove('is-active');
      }, { passive: true });

      // Prevent default click behavior on mobile to avoid double navigation
      link.addEventListener('click', function(e) {
        if ('ontouchstart' in window) {
          e.preventDefault();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
